export default __webpack_public_path__ + "media/builders/background-circle-bottom-7b0078e9.png";